import React from 'react'
import { StyledShopAnnotation, StyledShopAnnotationWmo } from './ShopWarrantyMessage.css'
import useWmoEnabled from '../../../hooks/useWmoEnabled'

interface ShopWarrantyMessageProps {
  short?: boolean
}

const ShopWarrantyMessage: React.FC<ShopWarrantyMessageProps> = ({ short = false }) => {
  const isWmoEnabled = useWmoEnabled()
  const StyledComponent = isWmoEnabled ? StyledShopAnnotationWmo : StyledShopAnnotation

  return (
    <StyledComponent>
      <span>*</span>
      {short ? (
        <>
          <span>Pay at the shop.</span>
          {' '}
          <span>Service warranty provided by the installer.</span>
        </>
      ) : (
        <>
          <span>Pay for install at the shop.</span>
          {' '}
          <span>Includes a 12-month/ 12,000-mile service warranty from the installer.</span>
        </>

      )}
    </StyledComponent>
  )
}

export default React.memo(ShopWarrantyMessage)
